import { render, staticRenderFns } from "./FormFieldBuilder.vue?vue&type=template&id=5fc6e842&scoped=true"
import script from "./FormFieldBuilder.vue?vue&type=script&lang=js"
export * from "./FormFieldBuilder.vue?vue&type=script&lang=js"
import style0 from "./FormFieldBuilder.vue?vue&type=style&index=0&id=5fc6e842&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc6e842",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fc6e842')) {
      api.createRecord('5fc6e842', component.options)
    } else {
      api.reload('5fc6e842', component.options)
    }
    module.hot.accept("./FormFieldBuilder.vue?vue&type=template&id=5fc6e842&scoped=true", function () {
      api.rerender('5fc6e842', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-builder/FormFieldBuilder.vue"
export default component.exports